import React, { FC } from 'react';

import {
  Flex,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react';

import { Form, Formik } from 'formik';

import FormikInput from 'components/primitives/FormikInput';
import FormikSwitch from 'components/primitives/FormikSwitch';
import GroupSelect from 'components/primitives/GroupSelect';
import SiteMultiSelect from 'components/primitives/SiteMultiSelect';

import {
  getInitialValues,
  validationSchema,
} from './EditCustomerContactModal.utils';

import { EditCustomerModalViewProps } from './EditCustomerContactModal.props';

const labelProps = {
  fontSize: '12px',
  color: '#afafaf',
};

const EditCustomerModalView: FC<EditCustomerModalViewProps> = (props) => {
  const { isOpen, contact, onClose, onUpdate, isCreating } = props;

  return (
    <Modal
      size="6xl"
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent borderRadius="30px">
        <ModalCloseButton _focus={{ outline: 'none' }} />
        <ModalHeader color="support.500" textAlign="center">
          Edit customer contact - {contact?._id || ''}
        </ModalHeader>
        <ModalBody>
          <Flex direction="column" p={6}>
            <Formik
              initialValues={getInitialValues(contact)}
              validationSchema={validationSchema}
              validate={(values) => {
                const errors: any = {};
                if (values.groups.length === 0 && values.sites.length === 0) {
                  errors.groups = 'Please select at least one group or site';
                  errors.sites = 'Please select at least one group or site';
                }

                return errors;
              }}
              onSubmit={onUpdate}>
              {({ isValid, values }) => (
                <Form>
                  <Flex gap="20px">
                    <FormikInput
                      name="fname"
                      label="First Name(*)"
                      labelProps={labelProps}
                      placeholder="your text here"
                    />
                    <FormikInput
                      name="lname"
                      label="Last Name(*)"
                      labelProps={labelProps}
                      placeholder="your text here"
                    />
                    <FormikInput
                      name="role"
                      label="Role"
                      labelProps={labelProps}
                      placeholder="your text here"
                    />
                  </Flex>
                  <Flex mt={6} gap="20px">
                    {/* <FormikSelectInput
                      placeholder="Select Wash Hub"
                      label="Wash Hub"
                      name="washHub">
                      {washHubs?.map((w) => (
                        <option key={w._id} value={w._id}>
                          {w?.name || ''}
                        </option>
                      ))}
                    </FormikSelectInput> */}
                    <FormikInput
                      type="email"
                      name="email"
                      label="Email"
                      labelProps={labelProps}
                      placeholder="your text here"
                    />
                    <FormikInput
                      type="number"
                      name="phone"
                      label="Phone"
                      labelProps={labelProps}
                      placeholder="your text here"
                    />
                  </Flex>

                  <GroupSelect values={values.groups} />

                  <SiteMultiSelect values={values.sites} />
                  <Flex mt={6} alignItems="center">
                    <FormikSwitch name="isArchived" />
                    <Text ml={2} {...labelProps} fontWeight="bold">
                      Archive
                    </Text>
                  </Flex>
                  <Flex my={12} flexDirection="row" justifyContent="center">
                    <Button
                      variant="outline"
                      marginRight="10px"
                      isDisabled={isCreating}
                      w="134px"
                      onClick={onClose}>
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      isLoading={isCreating}
                      isDisabled={!isValid}
                      w="134px">
                      Update
                    </Button>
                  </Flex>
                </Form>
              )}
            </Formik>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EditCustomerModalView;
